module.exports = __webpack_public_path__ + "img/layer-29.21008aa2.png";